import type { ScalesResultT } from '@mentimeter/visualizations';

interface ScalesDataT extends ScalesResultT {
  session: number;
  labelIndex: number;
  totalScore: number | null;
  skips: number;
  distribution: Distribution[];
}

interface Distribution extends Omit<ScalesResultT, 'score'> {
  score: number;
  count: number;
  labelIndex: number;
}

export function getSkips(respondents: number, scores: ScalesDataT['score']) {
  const votes = sumNumbers(Object.values(scores));
  return respondents - votes;
}

function sumNumbers(numbers: number[]) {
  return numbers.reduce((m, n) => m + n, 0);
}
